import script from "./CarPurchase.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarPurchase.vue?vue&type=script&setup=true&lang=ts"

import "./CarPurchase.vue?vue&type=style&index=0&id=ad5792e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad5792e4"]])

export default __exports__